import { render, staticRenderFns } from "./enrollment.vue?vue&type=template&id=618e35fb&scoped=true"
import script from "./enrollment.vue?vue&type=script&lang=js"
export * from "./enrollment.vue?vue&type=script&lang=js"
import style0 from "./enrollment.vue?vue&type=style&index=0&id=618e35fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e35fb",
  null
  
)

export default component.exports